/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2022-10-28 11:21:22
 */
/* eslint-disable */
import React, { useState, ChangeEvent } from 'react'
import { useAppSelector } from '../../app/hooks'
import { Button, Form, Input } from 'antd'
import classnames from 'classnames'
import todaycam_logo from '../../images/todaycam_logo.png'
import { calcCharactersLength } from '../../utils/utils'
import sensors from '../../utils/sensors'
import { UserOutlined } from '@ant-design/icons'

interface InputNamePanelProps {
  onSubmit: (nickname: string) => void
}

function InputNamePanel(props: InputNamePanelProps) {
  const { onSubmit } = props
  const isDesktop = useAppSelector((state) => state.main.isDesktop)

  type ValidateStatus = '' | 'success' | 'warning' | 'error' | 'validating'
  const [nickname, setNickname] = useState('')
  const [validateStatus, setValidateStatus] = useState<ValidateStatus>('')
  const [nicknameHelp, setNicknameHelp] = useState('')
  const composingRef = React.useRef(false)

  // eslint-disable-next-line prefer-regex-literals
  const filterRe = React.useMemo(
    () => ({
      special: new RegExp('[<>&"\'`#;\\\\\\x00-\\x1f\\x7f]', 'g'),
      emoji: new RegExp('\\p{Extended_Pictographic}', 'gu')
    }),
    []
  )
  const applyFilter = React.useCallback(
    (value: string) =>
      value
        .replace(filterRe.special, '')
        .replace(filterRe.emoji, '')
        .slice(0, 20),
    [filterRe]
  )

  const handleNicknameChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (composingRef.current) {
      setNickname(e.target.value)
      return
    }
    const filtered = applyFilter(e.target.value)
    setNickname(filtered)
    if (!calcCharactersLength(filtered, 20)) {
      setValidateStatus('error')
      setNicknameHelp('姓名最多可输入10个汉字')
    } else {
      setValidateStatus('')
      setNicknameHelp('')
    }
  }

  const handleSubmit = () => {
    sensors.track('web_workgroup_login_profile_click_done')
    onSubmit(nickname)
  }

  return (
    <div
      className={classnames('panel', {
        animated: !isDesktop,
        zoomIn: !isDesktop
      })}
      key="login-panel"
    >
      <img className="logo" src={todaycam_logo} alt="今日水印相机" />
      <h3 className="title" id="title">
        完善个人信息
      </h3>

      <Form className="login-form">
        <Form.Item validateStatus={validateStatus} help={nicknameHelp}>
          <Input
            size="large"
            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="真实姓名"
            value={nickname}
            onChange={handleNicknameChange}
          />
        </Form.Item>
        <Form.Item>
          <Button
            className="login-button"
            style={{ marginTop: '144px' }}
            type="primary"
            disabled={!!validateStatus || !nickname}
            onClick={handleSubmit}
          >
            完成
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default InputNamePanel
